<Modal
    id="move-resources-modal-id"
    bind:enabled={showMoveResourcesModal}
    titleText={i18n.moveResourcesHeading}
    confirmText={i18n.move}
    cancelText={i18n.dontMove}
    on:confirm={moveResources}
    on:close={cancel}
>
    <div slot="body">
        {#if initialTopicLabel}
            <div class="topic-modal__info">{i18n.moveResourcesChangeTopicInfoText.replace("{0}", initialTopicLabel).replace("{1}", selectedTopicLabel)}</div>
        {:else}
            <div class="topic-modal__info">{i18n.moveResourcesAddTopicInfoText.replace("{0}", selectedTopicLabel)}</div>
        {/if}
    </div>
</Modal>


<script>
    import Modal from "@itslearning/prometheus/assets/modals/Modal/v2/Modal.svelte";
    import { createEventDispatcher } from "svelte";
    import i18n from "../../i18n";

    export let showMoveResourcesModal = false;
    export let selectedTopicId;
    export let selectedTopicLabel;
    export let initialTopicLabel;

    const dispatch = createEventDispatcher();

    function moveResources() {
        dispatch("moveResources", {
            topicId: selectedTopicId
        });
    }

    function cancel() {
        dispatch("cancel");
    }

</script>
